import React, { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deleteCarData } from "../services/indexDBService";
import {
  carCount,
  setCars,
  setRetake,
  setUploaded,
} from "../Redux/Features/carSlice";
import Modal from "../Components/Modal";
import Tick from "../Assets/Images/Vector.png";
import Close from "../Assets/Images/Close.svg";
import CarF from "../Assets/Images/carF.svg";
import CarT from "../Assets/Images/carT.svg";
import Uploading from "../Assets/Images/uploading.svg";
import Logo from "../Assets/Images/logo_hdfc.png";
import axios from "axios";
import { Circle } from "rc-progress";
import uploadFinished from "../Assets/Images/uploadFinished.svg";
import uploadArrow from "../Assets/Images/uploadArrow.svg";
import DamageForm from "../Components/DamageForm";
// import {
//   setDamageRecorded,
//   setDamageData,
// } from "../Redux/Features/damageSlice";
import CustomModal from "../Components/CustomModal";
import { networkStatus } from "../services/networkStatusService";
import { setUploadLater } from "../Redux/Features/uploadLaterSlice";
import { getDynamicToken } from "../utils/authUtils";

import { useTelemetry } from "../telemetry/TelemetryProvider";
import { updateClaimStatus } from '../utils/updateClaimStatus';


const Upload = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);
  const [networkModalOpen, setNetworkModalOpen] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const car = useSelector((state) => state.car);
  const sessionId = useSelector((state) => state.car.sessionId);
  const isClaim = useSelector((state) => state.isClaim);
  const isPAYD = useSelector((state) => state.isPAYD.isPAYD);
  const odometer = useSelector((state) => state.isPAYD.odometer_reading);
  const modelWrapper = useSelector((state) => state.model);
  const breakin = useSelector((state) => state.breakin);
  const [whatsappSend, setWhatsappSend] = useState(false);

  const [isClaimDamageLive, setIsClaimDamageLive] = useState(true);
  const [submitBtnVisible, setSubmitBtnVisible] = useState(true);
  const [missingImagesMessage, setMissingImagesMessage] = useState(null);
  const [showMissingModal, setMissingModal] = useState(false);
  const [storageValue, setStorageValue] = useState(
    localStorage.getItem("lc_damage")
  );

  const [updateCar, setUpdatedCar] = useState([]);
  const [submitBtn, setSubmitBtn] = useState(false);
  const [submitName, setSubmitname] = useState("Upload");
  const [lastHealthCheck, setLastHealthCheck] = useState(null);

  const { track, tSessionId } = useTelemetry();

  useEffect(() => {
    const tempCar = [];
    car.data.forEach((e) => {
      const validation = modelWrapper.validation.find((j) => j.key === e.key);
      if (validation && validation.result) {
        const detection = validation.result.car;
        const carInFrame = validation.result.car_in_frame;
        const d_precision = validation.result.d_precision;
        const h_precision = validation.result.h_precision;
        const v_precision = validation.result.v_precision;
        const final_side = validation.result.final_side;
        var newStr = e.imgId.replace(/_/g, "");
        if (newStr == "PartialRearLeft") {
          newStr = "left_rear";
        } else if (newStr == "PartialFrontLeft") {
          newStr = "left_front";
        } else if (newStr == "PartialFrontRight") {
          newStr = "right_front";
        } else if (newStr == "PartialRearRight") {
          newStr = "right_rear";
        }
        const isCarValue = detection
          ? newStr !== final_side
            ? "Wrong Angle "
            : carInFrame
              ? "Car Detected"
              : d_precision <= -2
                ? "Too Far"
                : d_precision >= 2
                  ? "Too Close"
                  : h_precision <= -2
                    ? "Too Left"
                    : h_precision >= -2
                      ? "Too Right"
                      : v_precision <= -2
                        ? "Too Up"
                        : v_precision >= -2 && "Too Down"
          : "Car Not Detected";

        const isValidCar =
          validation.result.car && validation.result.car_in_frame;

        tempCar.push({
          ...e,
          progress: 0,
          isCar: isValidCar || detection === true, // ← sets isCar to true if detected
          message: validation ? isCarValue : "",
        });
      } else tempCar.push({ ...e, progress: 0 });
    });
    setUpdatedCar(tempCar);
    console.log(tempCar);
  }, []);

  if (car.uploaded) navigate("/thank");

  const dataURItoBlob = async (dataURI, fileName) => {
    let byteString = atob(dataURI.split(",")[1]);

    // separate out the mime component
    let mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    // write the bytes of the string to an ArrayBuffer
    let ab = new ArrayBuffer(byteString.length);
    let ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    //New Code
    let bg = new Blob([ab], { type: mimeString });
    return new File([bg], `${fileName}.jpg`, { type: "image/jpeg" });
  };
  const isEveryUpload = updateCar.every((item) => item.progress >= 100);

  async function testDownloadSpeed() {
    const now = Date.now();
    const lastCheck = localStorage.getItem("last_health_check");

    // If last check was within 60 seconds, skip API call
    if (lastCheck && now - parseInt(lastCheck, 10) < 120000) {
      return true; // Assume OK
    }

    setSubmitname("Checking Network...");
    const dynamicToken = await getDynamicToken();
    const isSpeedOk = await networkStatus(
      `${import.meta.env.VITE_API_URL}/api-health`,
      dynamicToken,
      1
    );

    if (isSpeedOk) {
      localStorage.setItem("last_health_check", now.toString());
    }

    return isSpeedOk;
  }

  const onSubmit = async () => {
    let isError = false; // Flag to track errors
    if (submitName === "Upload") {
      track('UPLOAD_CLICKED');
      setSubmitBtn(true);
      setSubmitname("Submit");
      if (isClaim) {
        if (!breakin?.claim_number) {
          navigate("/upload-error");
        }

        if (!breakin.no_cdf_sources.includes(breakin.source_app)) {
          setSubmitBtnVisible(false);
          document.title = "Claim Damage Form";
        }
        localStorage.removeItem("lc_damage");
      } else {
        if (!breakin?.BRKIN_ID) {
          navigate("/upload-error");
        }
      }
      let missingImages = [];

      //! Check for missing images

      updateCar.forEach((element) => {
        if (!element.isUploadImg || !element.isUploadBlob) {
          missingImages.push(element.name);
          // console.log(missingImages);
        }
      });
      if (missingImages.length > 0) {
        setSubmitBtn(false);
        setSubmitname("Upload");
        setSubmitBtnVisible(true);
        setMissingModal(true);
        track('ERROR_IN_UPLOAD_MODEL');
        await updateClaimStatus('MISSING_IMAGES_POPUP');
        const message = (
          <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
            The following angles are not perfect. Kindly retake:
            {missingImages.map((img) => `\n• ${img}`)}
          </pre>
        );
        setMissingImagesMessage(message);
        return;
      }

      //! Integrate Network API here.

      const isSpeedOk = await testDownloadSpeed();

      if (!isSpeedOk) {
        setSubmitBtn(false);
        setSubmitname("Upload");
        setSubmitBtnVisible(true);
        //window.alert("It seems you're in low network zone. Your images are stored, you can open the link later when in network")
        setNetworkModalOpen(true);
        track('ERROR_IN_UPLOAD_MODEL');
        return; // Stop further processing due to slow network
      }
      setSubmitname("Submit");
      // updateCar.forEach(async function(e, index, arr) {

      // Get token once before the loop
      const dynamicToken = await getDynamicToken();

      for await (let e of updateCar) {
        let result;
        let response;
        //! Fix for Base64 to Blob
        let imagefile = await dataURItoBlob(e.isUploadImg, e.imgId, e.name);
        let dat1 = new FormData();

        if (isClaim) {
          dat1.append("claim_num", breakin.claim_number);
          dat1.append("user_id", breakin.insured_name);
          dat1.append("last_image", e.name === "ODO Meter" ? "1" : "0");
          dat1.append("image_name", e.imgId);
          dat1.append(
            "source_app",
            breakin.source_app ? breakin.source_app : "WAPC"
          );
          // dat1.append("upload_type", car.retake ? "reupload" : "upload");
          dat1.append("upload_type", "upload");
          dat1.append("vehicle_type_id", "1");
          dat1.append("keep_images", "[]");
          dat1.append("DocType", "Image"); //
          dat1.append("DocID", "100456");
          dat1.append("DocName", e.imgId);
          dat1.append("claimType", "Own Damage");
          dat1.append("claimDocType", "Photos - First Inspection - Customer");
          dat1.append("policyNo", breakin.pol_num);
          dat1.append("surveyDate", breakin.loss_date ? breakin.loss_date : "");
          dat1.append("surveyTime", breakin.loss_time ? breakin.loss_time : "");
          dat1.append("fileCount", "1");
          let claimnocd = breakin.claim_number;
          claimnocd = claimnocd.replace("C", "") + "00000001";
          dat1.append("claimNoCd", claimnocd);
          dat1.append("source_name", `${import.meta.env.VITE_SOURCE_APP}`);
          dat1.append("first_image", "1");
          dat1.append("image", imagefile);
          dat1.append(
            "Vehicle_Reg_No",
            breakin.registration ? breakin.registration : ""
          );
          dat1.append("lat", e.latitude ?? 19.1624);
          dat1.append("lon", e.longitude ?? 72.9376);
        } else if (isPAYD) {
          dat1.append("claim_num", breakin.BRKIN_ID);
          dat1.append("user_id", breakin.Name);
          dat1.append("vehicle_type_id", "1");
          dat1.append(
            "last_image",
            e.imgId === "ODO_Meter" ||
              String(updateCar.length) === String(e.key)
              ? "1"
              : "0"
          );
          if (e.imgId === "ODO_Meter") {
            dat1.append(
              "odometer_reading",
              Number.isFinite(Number(odometer)) ? Number(odometer) : 0
            );
          }
          dat1.append("image_name", e.imgId);
          // dat1.append("upload_type", car.retake ? "reupload" : "upload");
          dat1.append("upload_type", "upload");
          dat1.append("source_app", "PAYD_WC");
          dat1.append("image", imagefile);
          dat1.append("keep_images", "[]");
          dat1.append("DocType", "Image");
          dat1.append("DocID", "100456");
          dat1.append("DocName", e.imgId);
          dat1.append("UserType", "Customer");
          dat1.append("surveyor_name", "user");
          dat1.append("inbox_code", "23");
          dat1.append("claimType", "Own Damage");
          dat1.append("claimDocType", "Photos - First Inspection - Customer");
          dat1.append("policyNo", "2312204037231600000");
          dat1.append("surveyDate", breakin.INSPECTIONDATE);
          dat1.append("surveyTime", "");
          dat1.append("fileCount", "1");
          dat1.append("claimNoCd", "100456");
          dat1.append("source_name", `${import.meta.env.VITE_SOURCE_APP}`);
          dat1.append("first_image", "1");
          dat1.append("Vehicle_Reg_No", breakin.REGISTRATION_NUMBER);
          dat1.append("Product_Type", breakin.Product_x0020_Type);
          dat1.append("lat", e.latitude ?? 19.1624);
          dat1.append("lon", e.longitude ?? 72.9376);
        } else {
          dat1.append("claim_num", breakin.BRKIN_ID);
          dat1.append("user_id", breakin.Name);
          dat1.append("vehicle_type_id", "1");
          dat1.append(
            "last_image",
            e.imgId === "RC_Book_Back" ||
              String(updateCar.length) === String(e.key)
              ? "1"
              : "0"
          );
          dat1.append("image_name", e.imgId);
          // dat1.append("upload_type", car.retake ? "reupload" : "upload");
          dat1.append("upload_type", "upload");
          dat1.append("source_app", "WAPB");
          dat1.append("image", imagefile);
          dat1.append("keep_images", "[]");
          dat1.append("DocType", "Image");
          dat1.append("DocID", "100456");
          dat1.append("DocName", e.imgId);
          dat1.append("UserType", "Customer");
          dat1.append("surveyor_name", "user");
          dat1.append("inbox_code", "23");
          dat1.append("claimType", "Own Damage");
          dat1.append("claimDocType", "Photos - First Inspection - Customer");
          dat1.append("policyNo", "2312204037231600000");
          dat1.append("surveyDate", breakin.INSPECTIONDATE);
          dat1.append("surveyTime", "");
          dat1.append("fileCount", "1");
          dat1.append("claimNoCd", "100456");
          dat1.append("source_name", `${import.meta.env.VITE_SOURCE_APP}`);
          dat1.append("first_image", "1");
          dat1.append("Vehicle_Reg_No", breakin.REGISTRATION_NUMBER);
          dat1.append("Product_Type", breakin.Product_x0020_Type);
          dat1.append("lat", e.latitude ?? 19.1624);
          dat1.append("lon", e.longitude ?? 72.9376);
        }

        // if (navigator.geolocation) {
        //   navigator.geolocation.getCurrentPosition((position) => {
        //     const lat = position.coords.latitude;
        //     const lon = position.coords.longitude;
        //     dat1.append("lat", lat);
        //     dat1.append("lon", lon);
        //   });
        // }
        // else {
        //   dat1.append("lat", "1.148638");
        //   dat1.append("lon", "2.881086");
        // }

        var config = {
          method: "post",
          url: `${import.meta.env.VITE_API_URL}/ai_image_upload`,
          headers: {
            Authorization: `Bearer ${dynamicToken}`,
          },
          onUploadProgress: (data) => {
            const percentCompleted = Math.round(
              (data.loaded / data.total) * 100
            );

            updateCar[e.key - 1].progress = percentCompleted;

            setUpdatedCar([...updateCar]);
          },
          data: dat1,
        };
        await axios(config)
          .then(function (response) {
            result = JSON.stringify(response.data);
            return result;
          })
          // eslint-disable-next-line no-loop-func
          .catch(async function (error) {
            // isError = true;
            console.log(error);
            if (isClaim) {
            await updateClaimStatus('API_TIMEOUT_ERROR');
            }
          });
      }
    } else if (submitName === "Submit") {
      track('SUBMIT_CLICKED');
      dispatch(setUploaded());
      // console.log(sessionId)
      if (sessionId) {
        try {
          await deleteCarData(sessionId);
          console.log("IndexedDB data deleted successfully");
        } catch (error) {
          console.warn("Error deleting data from IndexedDB:", error);
        }
      }
      navigate("/thank");
    }
    // if (isError) {
    //   navigate("/upload-error")
    // }
  };

  useEffect(() => {
    if (!submitBtnVisible && isClaim && isClaimDamageLive) {
      window.scrollTo({
        top: 1450,
        behavior: "smooth",
      });
    }
  }, [submitBtnVisible]);

  useEffect(() => {
    const unloadCallback = (event) => {
      event.preventDefault();
      event.returnValue = "";
      return "";
    };
    window.addEventListener("beforeunload", unloadCallback);
    return () => {
      window.removeEventListener("beforeunload", unloadCallback);
    };
  }, []);

  useEffect(() => {
    const sendWhatsAppMessage = async () => {
      if (updateCar.length > 0 && !whatsappSend && !isClaim) {
        if (car.uploaded || isEveryUpload) {
          setWhatsappSend(true);

          try {
            const dynamicToken = await getDynamicToken();

            const requestOptions = {
              method: "POST",
              headers: {
                Authorization: `Bearer ${dynamicToken}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                mobile_no: breakin.MOBILE_NUMBER,
                template: "MYRA_VEHICLE_INSPECTION_SUCCESS",
              }),
            };

            await fetch(
              `${import.meta.env.VITE_API_URL}/wp_send_sms`,
              requestOptions
            );
          } catch (error) {
            console.error("Error sending WhatsApp message:", error);
          }
        }
      }
    };

    sendWhatsAppMessage();
  }, [updateCar]);

  const handleModalYes = async () => {
    setNetworkModalOpen(false);
    onSubmit();
  };

  const handleModalNo = async () => {
    await updateClaimStatus('UPLOAD_LATER_SELECTED');
    dispatch(setUploadLater(true));
    setNetworkModalOpen(false);
    navigate("/thank");
  };

  const handleMissingModal = () => {
    setMissingModal(false);
  };
  // if(isEveryUpload) dispatch(setUploaded())
  return (
    <>
      <div className="container">
        <div className="header_container">
          {submitName === "Checking Network..." ? (
            <>
              <span>Please wait</span>
              <p>We are checking for network</p>
            </>
          ) : (
            <>
              <span>Please click {submitName}</span>
              <p>to {submitName.toLowerCase()} your files</p>
            </>
          )}
        </div>
        {updateCar && updateCar.length > 0
          ? updateCar.map((e) => {
            // Get the blob URL for this item
            return (
              <div className="upload_container" key={e.key}>
                <div className="image">
                  <div className="predicted" style={{ position: "relative" }}>
                    {e.isUpload && (
                      <img
                        id="prediction"
                        className="prediction"
                        src={e.isCar ? CarT : CarF}
                        alt={e.isCar ? "/" : "X"}
                      />
                    )}
                    <img
                      className="upload_img"
                      onClick={() => {
                        setModalOpen(true);
                        // Use the blob URL for preview data too
                        const updated = {
                          ...e,
                          isUploadImg: e.isUploadBlob,
                        };
                        setPreviewData(updated);
                      }}
                      src={e.isUploadBlob || e.stencil} // Use blob URL here!
                      alt="car"
                    />
                  </div>
                  <div className="name">
                    <p className="e.imgId_name">{e.name.toUpperCase()}</p>
                    {!submitBtn && (
                      <button
                        style={{ backgroundColor: "#888888" }}
                        onClick={() => {
                          dispatch(carCount(e.key));
                          dispatch(setRetake());
                          navigate("/inspection");
                        }}
                      >
                        Retake
                      </button>
                    )}
                  </div>
                </div>
                {submitBtn && (
                  <div className="detected">
                    {e.progress < 100 && (!car.uploaded || isEveryUpload) ? (
                      <div
                        style={{
                          width: "44px",
                          height: "44px",
                          position: "relative",
                        }}
                      >
                        <Circle
                          percent={e.progress}
                          strokeWidth={5}
                          steps={{
                            count: 10,
                            space: 7,
                          }}
                          strokeColor={"#e42125"}
                        />
                        <img
                          src={uploadArrow}
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "11px",
                          }}
                          alt={`${e.progress}`}
                        />
                      </div>
                    ) : (
                      <img src={uploadFinished} alt="Uploaded" />
                    )}
                    <p
                      className="upload_text"
                      style={{
                        color: e.progress < 100 ? "#EF7A7C" : "green",
                      }}
                    >
                      {e.progress < 100 ? "Uploading..." : "Upload Finished"}
                    </p>
                  </div>
                )}
              </div>
            );
          })
          : null}
        {!breakin.no_cdf_sources.includes(breakin.source_app) &&
          isClaim &&
          isClaimDamageLive & (submitName === "Submit") ? (
          <DamageForm />
        ) : (
          <button
            className="submitBtn"
            disabled={submitName === "Submit" && !isEveryUpload}
            style={{
              background:
                submitName === "Upload"
                  ? "#EC6466"
                  : !isEveryUpload
                    ? "#B0B0B0"
                    : "#0F871B",
              display: submitBtnVisible ? "block" : "none",
            }}
            onClick={onSubmit}
          >
            <span>{submitName}</span>
          </button>
        )}
      </div>

      {modalOpen && (
        <Modal>
          <div className="modalContainerRotate ">
            <div className="titleCloseBtn">
              <button
                onClick={() => {
                  setModalOpen(false);
                }}
              >
                <img src={Close} alt="X" />
              </button>
            </div>
            <div className="body">
              <h2>{previewData.name}</h2>
              <img src={previewData.isUploadImg} alt="car" />
              {!submitBtn && (
                <button
                  onClick={() => {
                    // const copyData = JSON.parse(JSON.stringify(car.data));
                    // const foundIndex = copyData.findIndex(
                    //   (elem) => Number(elem.key) === Number(previewData.key)
                    // );
                    // if (foundIndex > -1) {
                    //   copyData[foundIndex].isUploadImg = false;
                    //   copyData[foundIndex].isUpload = false;
                    // }

                    // dispatch(setCars(copyData));

                    dispatch(carCount(previewData.key));
                    dispatch(setRetake());
                    navigate("/inspection");
                  }}
                  id="cancelBtn"
                >
                  Retake
                </button>
              )}
            </div>
          </div>
        </Modal>
      )}
      {/* Claim Modal */}
      <CustomModal
        open={networkModalOpen}
        message={
          "It seems you're in low network zone. Your images are stored, you can open the link later when in network"
        }
        yesText="Try again"
        noText="Upload later in network"
        onYes={handleModalYes}
        onNo={handleModalNo}
      />
      {/* Missing Images Modal */}
      <CustomModal
        open={showMissingModal}
        message={missingImagesMessage}
        yesText="Retake"
        noText="Cancel"
        onYes={handleMissingModal}
        onNo={handleMissingModal}
      />
    </>
  );
};

export default Upload;
